import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { InspectionDocument, inspectionPullQueryBuilder } from './queryBuilder';

export function inspectionsFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<InspectionDocument> {
  const syncConfig = configBuilder<InspectionDocument>(RxdbCollectionNameV2.INSPECTIONS);
  doNotAutoSync(syncConfig);

  pull(syncConfig, inspectionPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy had Inspections pulling on LiveInterval.MINUTES_15
  return create(RxdbCollectionNameV2.INSPECTIONS, replicationState, [sites]);
}
